<template>
  <div class="modal__content">
    <div class="text-center mb30" v-if="args.projectUser.avatarKey">
      <img :src="'/serve/s/' + args.projectUser.avatarKey + '?w=96&h=96'" class="img-circle"
           :alt="args.projectUser.name">
    </div>

    <div class="flex flex--justify-center">
      <div class="form-row mb0 mr30">
        <label>User Name</label>
        <h4 class="text-regular">{{args.projectUser.name}} {{args.projectUser.surname}}</h4>
      </div>

      <div class="form-row mb0 mr30"
           v-if="checkUserRole(args.userRole, ['admin', 'projectManager']) || (checkUserRole(args.userProjectRole, ['owner', 'editor', 'viewer']) && checkUserRole(args.projectUser.userProjectRole, ['owner', 'editor', 'viewer', 'admin', 'projectManager']))">
        <label>Email</label>
        <h4 class="text-regular mb0"><a :href="'mailto:' + args.projectUser.email">{{args.projectUser.email}}</a></h4>
      </div>

      <div class="form-row mb0">
        <label>Role</label>
        <h4 class="text-regular">{{args.projectUser.userProjectRole | titleize}}</h4>
      </div>
    </div>

    <div class="flex flex--justify-center mt30">
      <button class="btn btn--wide btn--gray-2" @click="$bus.$emit('modalClose')" type="button">Close</button>
    </div>
  </div>
</template>

<script>
  import CheckUserRoleMixin from 'modules/mixins/CheckUserRole'

  export default {
    name: 'UserInfoModal',

    props: {
      args: {
        type: Object,
        required: true
      }
    },

    mixins: [CheckUserRoleMixin]
  }
</script>



// WEBPACK FOOTER //
// UserInfoModal.vue?0c5f8106